import { Controller } from "@hotwired/stimulus"

// Scroll-triggered reveal for marketing pages. Adds `is-visible` once an element
// enters the viewport, then unobserves. Respects prefers-reduced-motion by
// showing everything immediately.
export default class extends Controller {
  static targets = ["item"]

  connect() {
    if (this.itemTargets.length === 0) return

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    if (reducedMotion) {
      this.itemTargets.forEach((el) => el.classList.add("is-visible"))
      return
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          entry.target.classList.add("is-visible")
          this.observer.unobserve(entry.target)
        })
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    )

    this.itemTargets.forEach((el) => this.observer.observe(el))
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
